import { Command } from "@/app/common/base/command"
import { NpsResult } from "@/app/nps-feedback/entities/nps-result.entity"

export class NpsSubmitScoreCommand extends Command {
    public async run(score: number, npsToken: string) {
        const response = await this.client.post('/api/nps-feedback/score',{ score, npsToken })
        return response.asEntity(NpsResult)
    }
}
